import { useEffect, useState } from "react";
import { Table1 } from "../../components/table/Table1";
import { ChangeTitle, toastsuccessmsg } from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { MdContentCopy } from "react-icons/md";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DOMPurify from "dompurify";
import { IoClose } from "react-icons/io5";

const Tools = () => {
  ChangeTitle("Tools");

  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(5);
  const [sortField, setSortField] = useState("created");
  const [sortOrder, setSortOrder] = useState("desc");
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState([]); // All Data List
  const [instructionsData, setInstructionsData] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Opem Modal Popup Form Function
  const openModal = (data) => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
    setInstructionsData(data);
  };
  // Close Modal Popup Form Function
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    setInstructionsData("");
  };

  // Documents List Api call
  const viewToolsList = async (search, sortOrder, sortField, limit, offset) => {
    const param = {
      type: "Tools",
      term: search,
      sort: sortOrder,
      sortBy: sortField,
      limit: limit,
      offset: offset,
    };
    var response = await postData("download/list", param, apiHeader(false));

    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const totalRecords = response.data.data.totalRecord;
      setData(data);
      setTotalRecords(totalRecords);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewToolsList(search, sortOrder, sortField, limit, offset);
  }, [search, sortOrder, sortField, limit, offset]);

  // table columns
  const columns = [
    {
      class: "min-w-[100px] text-center",
      name: <label className="st-head-tr-th-text">Sr. no.</label>,
      cell: (row, rowIndex, baseIndex) => {
        const srNo = baseIndex + rowIndex + 1;
        return <p className="text-center">{srNo}</p>;
      },
      sortable: false,
      field: "_id",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Description</label>,
      cell: (row) => (
        <p
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(row.documentName),
          }}
        />
      ),
      sortable: true,
      field: "description",
    },
    {
      class: "min-w-[150px] text-center",
      name: <label className="st-head-tr-th-text">Date</label>,
      cell: (row) => <p className="text-center">{row.date}</p>,
      sortable: false,
      field: "date",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Link</label>,
      cell: (row) => (
        <div className="flex items-center">
          <a href={row.link} target="_blank">
            {row.link}
          </a>
          {row.link && (
            <button
              className="btn btn-sm btn-light-info ms-3 py-1 px-2 table-doc-icon"
              title="Copy"
              onClick={() => {
                navigator.clipboard.writeText(row.link);
                toastsuccessmsg("Link Copied.");
              }}
            >
              <MdContentCopy className="fs-3" />
            </button>
          )}
        </div>
      ),
      sortable: true,
      field: "link",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Instructions</label>,
      cell: (row) => (
        <span role="button" onClick={() => openModal(row.instructions)}>
          Read Me
        </span>
      ),
      sortable: false,
      field: "section",
    },
  ];

  const handleSort = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
    setOffset(0); // Reset to the first page on sort change
    viewToolsList(search, newSortOrder, field, limit, offset);
  };

  return (
    <>
      <ToastContainer />
      {isModalOpen && (
        <>
          <div
            onClick={() => closeModal()}
            className={`w-full fixed top-0 left-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[70%] lg:w-[50%] xl:w-[40%] xxl:container p-[2%] mx-auto my-[5%] top-[30%] md:my-[5%] lg:my-0 relative lg:top-[30%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Download Instructions</h1>
                <IoClose
                  onClick={() => closeModal()}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="h-[400px] overflow-y-auto">
                {instructionsData ? (
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: instructionsData,
                    }}
                  />
                ) : (
                  <div className="w-full text-center no-found">
                    No Instructions found
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <Table1
        className="px-[3%] md:px-[1%] pb-[3%] md:pb-[1%] pt-[10rem] mb-5 lg:mb-8"
        columns={columns}
        data={data}
        totalRecords={totalRecords}
        additionalField={""}
        searchPlaceholder="Search tools"
        searchValue={search}
        setSearchValue={(e) => {
          setSearch(e.target.value);
          setOffset(0);
        }}
        limit={limit}
        offset={offset}
        setOffset={setOffset}
        isAllowAllList={true}
        setLimit={setLimit}
        sortField={sortField}
        sortOrder={sortOrder}
        handleSort={handleSort}
      />
    </>
  );
};

export default Tools;
